<template>
    <div class="accord" v-bind:class="{ 'closed': isClosed }">
        <header v-on:click="onToggle"><a v-if="link" :href="link" v-on:click="onAnchorClick($event)" :data-id="'link' + linkName">{{ linkName }}</a>{{ title }}<span title="open / close"></span></header>
        <article v-if="!isClosed"><slot></slot></article>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true
            },
            link: {
                type: String,
                required: false
            },
            linkName: {
                type: String,
                required: false
            }
        },
        data: () => ({
            isClosed: false
        }),
        methods: {
            onToggle() {
                this.isClosed = !this.isClosed
            },
            onAnchorClick(e){
                e.preventDefault();
            }
        }
    }
</script>